export default __webpack_public_path__ + "static/ERAU-0d48c9644bbcdd9e4d802898d1a86321.svg";